import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { Form } from "antd";
import dayjs from "dayjs";

const ArrestDeatils = ({ data }) => {
  return (
    <Form labelAlign="left" key={data?.transactionId}>
      <StyledGridRow gutter={20}>
        <StyledGridCol lg={8}>
          <FormItem label="Arrest #">
            <TextField value={data?.arrestNumber ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Arrest By">
            <TextField value={data?.arrestedBy ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Jurisdiction">
            <TextField value={data?.jurisdiction ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Arrest Date/Time">
            <CommonDatePicker
              showTime
              format="MM/DD/YYYY HH:mm:ss A"
              value={data?.dateArrested ? dayjs(data.dateArrested) : null}
              disabled
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Arresting Officer">
            <TextField value={data?.arrestingOfficer ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Officer (Badge #)">
            <TextField value={data?.badgeNumber ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Commit Date/Time">
            <CommonDatePicker
              showTime
              format="MM/DD/YYYY HH:mm:ss A"
              value={data?.commitedDate ? dayjs(data.commitedDate) : null}
              disabled
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Committed By">
            <TextField value={data?.commitedBy ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="FBI #">
            <TextField value={data?.fbiNumber ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem label="Inmate ID">
            <TextField value={data?.inmateId ?? ""} readOnly />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default ArrestDeatils;
